export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12209.0e246f4b.jpg";